/**
 * Auth session data storage
 */
const STORAGE = window.localStorage

const KEY_PREFIX = 'auth_'

const KEYS = {
  CLIENT_ID: 'client_id',
  REFRESH_TOKEN: 'refresh_token',
  ACCESS_TOKEN: 'access_token',
  TOKEN_TYPE: 'token_type',
  SCOPE: 'scope',
  CREATED_AT: 'created_at',
  EXPIRES_IN: 'expires_in'
}

const getKey = key => KEY_PREFIX + key

export default {
  store (data) {
    Object.keys(data).forEach(key => {
      STORAGE.setItem(getKey(key), data[key])
    })
  },

  clear () {
    Object.values(KEYS).forEach(key => {
      STORAGE.removeItem(getKey(key))
    })
  },

  clientID () {
    return STORAGE.getItem(getKey(KEYS.CLIENT_ID))
  },

  refreshToken () {
    return STORAGE.getItem(getKey(KEYS.REFRESH_TOKEN))
  },

  accessToken () {
    return STORAGE.getItem(getKey(KEYS.ACCESS_TOKEN))
  },

  tokenType () {
    return STORAGE.getItem(getKey(KEYS.TOKEN_TYPE))
  },

  scope () {
    return STORAGE.getItem(getKey(KEYS.SCOPE))
  },

  createdAt () {
    return ~~STORAGE.getItem(getKey(KEYS.CREATED_AT))
  },

  expiresIn () {
    const expiresIn = STORAGE.getItem(getKey(KEYS.EXPIRES_IN))
    return expiresIn === 'null' ? null : ~~expiresIn
  },

  expiresAt () {
    const expiresIn = this.expiresIn()
    return expiresIn === null ? null : this.createdAt() + expiresIn
  },

  isExpired () {
    const expiresAt = this.expiresAt()
    return expiresAt === null ? false : Math.ceil(Date.now() / 1000) > expiresAt
  },

  isValid () {
    return !!this.accessToken() && !!this.tokenType() && !this.isExpired()
  },

  hasAuthMaterial () {
    return !!this.accessToken() && !!this.tokenType()
  },

  authHeader () {
    return `${this.tokenType()} ${this.accessToken()}`
  }
}
